import { render, staticRenderFns } from "./VideoPopup.vue?vue&type=template&id=61843f40&scoped=true&"
import script from "./VideoPopup.vue?vue&type=script&lang=js&"
export * from "./VideoPopup.vue?vue&type=script&lang=js&"
import style0 from "./VideoPopup.vue?vue&type=style&index=0&id=61843f40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61843f40",
  null
  
)

export default component.exports